<ul class="no-bullet">
  @for (option of options; track option) {
  <li *stxPermitted="option.permission">
    @for (route of option.routes; track route; let isLast = $last) {
    <a [routerLink]="route.route" [queryParams]="route.queryParams">{{ route.name | translate }}</a>
    @if (!isLast) {
    <stx-value-separator></stx-value-separator>
    } }
  </li>
  }
</ul>
